import React from 'react';
import { Avatar } from '@chakra-ui/react';
import AutoFetchImage from 'components/AutoFetchImage';

const EnhancedAvatar = (props) => {
    const {
        size = 'md',
        name,
        src,
        ...other
    } = props;
    const sizeMap = {
        'xs': '21px',
        'sm': '28px',
        'md': '42px',
        'lg': '56px',
        'xl': '84px',
        '2xl': '112px',
        '3xl': '112px'
    }
    return <>
        {
            src && !src.endsWith('.null')
                ? (<AutoFetchImage initialUrl={src} boxSize={sizeMap[size] || sizeMap['md']} rounded={'full'}  {...other} />)
                : (
                    <Avatar
                        size={size}
                        name={name}
                        {...other}
                    />
                )
        }
    </>;
};

export default EnhancedAvatar;
